import { IconRenderer } from 'braid-design-system';

export const IconDot = () => (
  <IconRenderer>
    {({ className }) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={className}
        fill="currentColor"
      >
        <circle cx="12" cy="12" r="3" />
      </svg>
    )}
  </IconRenderer>
);
